module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/notosanskr/notokr-regular.woff2
// module id = AZlP
// module chunks = 0